import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CollapseComponent {
  @Input() title: string = '';
  @Input() warning: boolean = false;

  isOpen: boolean = false;

  constructor() {}

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
